import React from "react";
import { ApolloError } from "@apollo/client";
import { Text } from "../design-system/components/Text";
import { Button } from "../design-system/components/Button";
import styled, { css } from "../styled";
import { getErrorMessage } from "../utils/error";
import withMargin, { WithMarginProp } from "../styled/withMargin";

interface Props {
  error?: Error | ApolloError | string;
  showContactSupportButton?: boolean;
  isCentered?: boolean;
  renderCustomButton?: (opts: { isNetworkError: boolean }) => React.ReactNode;
}

const ButtonRow = styled.div`
  display: flex;
  margin-top: ${p => p.theme.spacing.m};
`;

const Wrapper = styled.div<{ margin?: string }>`
  ${withMargin}
`;

const ButtonWrapper = styled.div<{ isCentered?: boolean }>`
  display: inline-block;
  margin-right: ${p => p.theme.spacing.m};

  ${p =>
    p.isCentered &&
    css`
      align-content: center;
      margin: 0 auto;
    `}
`;

export const ErrorMessage = ({
  margin,
  error,
  renderCustomButton,
  isCentered = false,
  showContactSupportButton = true
}: Props & WithMarginProp) => {
  const { message, isNetworkError } = getErrorMessage(error);

  const hasButton =
    isNetworkError || showContactSupportButton || renderCustomButton;

  let customButton = renderCustomButton
    ? renderCustomButton({ isNetworkError })
    : null;

  return (
    <Wrapper margin={margin}>
      <Text align={isCentered ? "center" : undefined}>{message}</Text>
      {hasButton && (
        <ButtonRow>
          {customButton && (
            <ButtonWrapper isCentered={isCentered}>
              {customButton}
            </ButtonWrapper>
          )}
          {isNetworkError && (
            <ButtonWrapper isCentered={isCentered}>
              <Button
                variant="secondary"
                label="Try Again"
                onClick={() => {
                  window.location.reload();
                }}
              />
            </ButtonWrapper>
          )}
          {/* You can't use intercom (or other digital means really) if there is a network error */}
          {!isNetworkError && showContactSupportButton && (
            <ButtonWrapper isCentered={isCentered}>
              <Button
                label="Contact support"
                variant="secondary"
                className="openIntercom"
              />
            </ButtonWrapper>
          )}
        </ButtonRow>
      )}
    </Wrapper>
  );
};
